import { convertStatus } from '@components/learningPath/utils';
import { SkillTreeCardProps as SkillTreeCard } from '@components/skillTree/skillTreeCard/skillTreeCard';
import { SkillTree } from 'network-utils/dist/core';

export const skillTreeMapping = (skillTreesData: SkillTree[]): SkillTreeCard[] => {
    const skillTrees = skillTreesData.map((skillTree: any) => {
        return {
            uuid: skillTree.uuid,
            name: skillTree.name,
            description: skillTree.description,
            completionDate: skillTree.progress?.completedAt,
            duration: skillTree.duration,
            potentialScore: skillTree.potentialScore,
            status: convertStatus(skillTree.progress?.status) || 'notStarted',
            skillTreeUrl: `/app/skillTree?uuid=${skillTree.uuid}`
        };
    });
    return skillTrees;
};

export const calcCourseProgress = (course: any) => {
    if (
        (['completed', 'attempts_exceeded'].includes(course.quizStatus) && course.completionPercentage === 100) ||
        (!course.quizStatus && course.completionPercentage === 100)
    )
        return 'completed';
    if (course.completionPercentage > 0) return 'inProgress';
    return 'notStarted';
};
